const C = (typeof window!=='undefined' && window.ReactDOMClient) || {};
export const createRoot = C.createRoot;
export const hydrateRoot = C.hydrateRoot;
